export const CONFIGURATION_CHANGE_ORIGIN = "configuration change origin";
export const CONFIGURATION_TYPE = "configuration type";
export const TASK_STATUS = "status_id";
export const TASK_TYPE = "task type";
